import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorStore } from '@state/error/error.store';

export const notFoundGuard: CanActivateFn = () => {
  const router = inject(Router);
  const errorStore = inject(ErrorStore);
  errorStore.showNotFound();
  router.navigate(['/home']);
  return false;
};
